import { useEffect } from 'react'

import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'

export const LivePulse = () => {
  const sv = useSharedValue<number>(0.75)

  useEffect(() => {
    sv.value = withRepeat(withTiming(1, { duration: 800 }), -1, true)
  }, [])

  const animatedStyle = useAnimatedStyle(
    () => ({
      transform: [{ scale: sv.value }],
      opacity: sv.value,
    }),
    []
  )

  return (
    <Animated.View
      style={[
        { width: 12, height: 12, backgroundColor: '#fff', borderRadius: 6 },
        animatedStyle,
      ]}
    />
  )
}
